module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "active-name": "base"
    }
  }, _vm._l((_vm.tab), function(item) {
    return _c('el-tab-pane', {
      attrs: {
        "label": item.title,
        "name": item.id
      }
    }, [_c('xform', {
      attrs: {
        "config": item.form.config,
        "data": item.form.data
      },
      on: {
        "submitSuccess": function($event) {}
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-358ee782!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/store/sys/setting.vue
// module id = 216
// module chunks = 2